<template>
  <div class="c-imab-score">
      <span class="c-imab-score__score font-family-futura">{{ this.score }}</span>
      <span class="c-imab-score__text font-family-futura">{{ $ucfirst($t('general.score', {catalog: 'app_mobile'})) }}</span>
  </div>
</template>

<script>
/**
 * Component ImabScore.vue
 *
 * @module ImabScore
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.6] app/src/APP_DASHBOARD/templates/components/Parts/ImabScore.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "ImabScore",
  props: {
    score: {
      type: Number,
      default: 123
    },
  },
};
</script>

<style lang="scss">
@import "../../../../scss/colors";

    .c-imab-score {
        width: 120px;
        height: 120px;
        background-color: map-get($coroColors, 'info-transparent-200');
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        border-radius: 8px;
    }

    .c-imab-score__score {
        font-size: 2.5em;
        font-weight: 500;
        color: map-get($coroColors, 'info-500');
    }

    .c-imab-score__text {
        font-size: 1em;
        font-weight: 500;
        color: map-get($coroColors, 'info-500');
    }

</style>